import type { ChartContext } from './chart.contract';

export class ChartEvent {
  originalEvent: Event;
  context: ChartContext;

  constructor(event: Event, context: ChartContext) {
    this.originalEvent = event;
    this.context = context;
  }
}
